// extracted by css-extract-rspack-plugin
export default {"Box":"empty-column-sash-module__Box__u5p2Nem"};